export const tableHeader = [
  { id: 'name', cellName: 'Name', isSort: true, defaultSortValue: 'asc' },
  { id: 'corporates', cellName: 'Corporates' },
  { id: 'email', cellName: 'Email' },
  {id: 'viewDashboard', cellName:'View Dashboard'},
  { id: 'admin', cellName: 'Admin' },
  { id: 'actions', cellName: 'Actions' },
];
